/**
 * @file Shared React component — components/common/FormFieldInfoTooltip.tsx.
 */

import React from "react";
import "../../styles/infoText.css";

/** Type definition — Form Field Info Tooltip Props. */
export interface FormFieldInfoTooltipProps {
  text?: string | null;
  ariaLabel?: string;
}

/**
 * Standard CMS info (i) tooltip for contributor form field labels.
 * Styles live in `src/styles/infoText.css` — change there for all forms.
 */
const FormFieldInfoTooltip: React.FC<FormFieldInfoTooltipProps> = ({
  text,
  ariaLabel,
}) => {
  const content = String(text ?? "").trim();
  if (!content) return null;

  return (
    <span className="tooltip-wrapper">
      <span
        className="form-field-info-icon"
        role="img"
        aria-label={ariaLabel ?? content}
      >
        i
      </span>
      <span className="tooltip-content">{content}</span>
    </span>
  );
};

/** React component — Form Field Info Tooltip. */
export default FormFieldInfoTooltip;
